import { DataService } from '../../utils/dataService'
import { message, error} from '../../notifications/displayMessage'
import { datadogLogs } from '@datadog/browser-logs'
import totalPay from '../../utils/totalPay'


import { AxiosResponse } from 'axios'
import config from '../../config/enviroment'
import { language } from '../../utils/language'
import { current } from '@reduxjs/toolkit'
import { catalogueUrlSegment } from '../../utils/catalogueUrl';
import { shouldShowMarcaBlancaModal } from '../../components/MarcaBlancaModal/shouldShow';
import { exceedsMarcaBlancaLimit, getCartUnits } from '../../utils/marcaBlancaCart';
import { showMarcaBlancaCartLimit } from './marcaBlancaActions';
import { captureCartReturnPath } from '../../utils/cartReturnPath';

export const LOADING_CART = 'LOADING_CART'
export const SHOW_CART = 'SHOW_CART'
export const HIDE_CART = 'HIDE_CART'
export const ADD_PRODUCT = 'ADD PRODUCT'
export const UPDATE_TOTAL_PRICE = 'UPDATE_TOTAL_PRICE'
export const DISCARD_PRODUCT = 'DISCARD_PRODUCT'
export const CART_ERROR = 'CART_ERROR'
export const DEACTIVATED_CART = 'DEACTIVATED_CART'
export const EMPTY_CAR = 'EMPTY_CAR'
export const IN_SUMMARY_PAGE = 'IN_SUMMARY_PAGE'
export const SHIP_CART = 'SHIP_CART'
export const FIND_SHOPPING_CART = 'FIND_SHOPPING_CART'
export const REF_PRODUCT_EDIT = 'REF_PRODUCT_EDIT'
export const UPDATE_QUANTITY_COUNTER = 'UPDATE_QUANTITY_COUNTER'
export const UPDATE_TAX = 'UPDATE_TAX'


export const handleShowCart = () => (dispatch: any) => {
  dispatch({
    type: SHOW_CART
  })
}

export const handleHideCart = () => (dispatch: any) => {
  dispatch({
    type: HIDE_CART
  })
}

export const isSummaryPage = (inPage: boolean) => (dispatch:any) => {
  dispatch({
    type: IN_SUMMARY_PAGE,
    payload: inPage
  })
}

export const handleShopping = (
  defaultLanguage: string,
  quantity: number,
  valueDelivery: number,
  operator: string,
  cartId: any,
  path: string,
  rediretPath: string | null,
  referenceId: any,
  productId: any,
  history: any
):((dispatch: any, getState: any) => Promise<boolean>) => async (dispatch: any, getState: any) => {
  const mbState = getState();
  const marcaBlancaMaxUnits = mbState.marcaBlanca?.client?.maxDataphoneUnits ?? 0;
  if (
    shouldShowMarcaBlancaModal(mbState.client?.id, config.marcaBlancaId) &&
    exceedsMarcaBlancaLimit(mbState.shoppingCart.cartInfo, quantity, marcaBlancaMaxUnits)
  ) {
    dispatch(showMarcaBlancaCartLimit());
    return true;
  }
  const _dataService = new DataService();
  const data: any = {
    url: path,
    origin: config.landingIdentifier,
    id: cartId,
    productId: productId,
    referenceId: referenceId,
    quantity: quantity,
    operator: operator,
    valueDelivery: valueDelivery,
  };

  dispatch({ type: LOADING_CART });

  try {
    const res = await _dataService.post("/catalogue/shoppingcart", data);
    if (res.status === 200 && res.data.success === true) {
      dispatch({
        type: ADD_PRODUCT,
        payload: {
          id: res.data.data.id,
          total: res.data.data.total,
          products: res.data.data.products,
          consumptionTaxAmountTotal: res.data.data.consumptionTaxAmountTotal,
          taxAmountTotal: res.data.data.taxAmountTotal,
          catalogueId: res.data.data.catalogueId,
          quantity: res.data.data.quantity,
          state: res.data.data.state,
          date: res.data.data.date,
          clientId: res.data.data.clientId,
          publicKey: res.data.data.publicKey,
          shippingCost: res.data.data.shippingCost,
        },
      });

      if (rediretPath) {
        history.push(
          `${rediretPath}/${res.data.data.id}`,
          { from: captureCartReturnPath() }
        );
        dispatch({ type: IN_SUMMARY_PAGE, payload: false });
      }

      return res.data.success;
    } else {
      if (res.data.titleResponse === "shopping cart abandoned or deleted") {
        message(language[defaultLanguage]["shoppingDelete"]);
        dispatch({ type: DEACTIVATED_CART });
      } else {
       // message(`${language[defaultLanguage]["error"]}.`);
        dispatch({ type: CART_ERROR });
      }

      return res.data.success; 
    }
  } catch (err:any) {
    error(`${language[defaultLanguage]["error"]}.`);
    datadogLogs.logger.info("error request handleShopping", {
      name: "post /catalogue/shoppingcart",
      body: data,
      error: err.message,
    });

    return false; 
  }
};

export const handleUpdateCart = (productCartList: any, cartId: any, path: string, defaultLanguage: any) => async (dispatch: any) => {
  const data: any = {
    url: path,
    products: productCartList,
    origin: config.landingIdentifier,
  }
  
  if (cartId) {
    data.shoppingCartId = cartId
  }
   dispatch({ type: LOADING_CART })
   onUpdateCarts(data, dispatch, defaultLanguage)
}

export const onUpdateCarts = (data: any, dispatch: any,defaultLanguage: any) : Promise<any> => {
  const _dataService = new DataService()
  return _dataService
  .post('/catalogue/shoppingcart/updateCarts',data)
  .then((res: AxiosResponse) => {
    if (res.status === 200 && res.data.success === true) {
      dispatch({
        type: ADD_PRODUCT,
        payload: {
          id: res.data.data.id,
          total: res.data.data.total,
          products: res.data.data.products,
          consumptionTaxAmountTotal: res.data.data.consumptionTaxAmountTotal,
          taxAmountTotal: res.data.data.taxAmountTotal,
          catalogueId: res.data.data.catalogueId,
          quantity: res.data.data.quantity,
          state: res.data.data.state,
          date: res.data.data.date,
          clientId: res.data.data.clientId,
          publicKey: res.data.data.publicKey,
          shippingCost: res.data.data.shippingCost,
        }
      })
      


    } else {
      if (res.data.titleResponse === 'shopping cart abandoned or deleted') {
        message(language[defaultLanguage]["shoppingDelete"])
        dispatch({
          type: DEACTIVATED_CART
        })
      } else {
        message(`${language[defaultLanguage]["error"]}.`)
        dispatch({
          type: CART_ERROR
        })
      }
    }


  })
  .catch((err) => {
    error(`${language[defaultLanguage]["error"]}.`)
    datadogLogs.logger.info('error request handleUpdateCart', { name: 'post /catalogue/shoppingcart', body: data, error: err.message })
  })
}

export const handleEditProduct = (
  position: number,
  quantity: number,
  valueDelivery: number,
  operator: string,
  amounts: Array<any>,
  productCartList: any,
  cartId: number,
  path: string,
  rediretPath: string | null,
  shopping: any,
  idCatalogo: number,
  history: any, 
  defaultLanguage: string
  ) => async(dispatch: any) => {
  const _dataService = new DataService()
  let productDetails

  const elementIndex = productCartList.findIndex(
    (element: any) => element.position === position
  )
  if (!productCartList[elementIndex].references || productCartList[elementIndex].references.length === 0) {

    productCartList.forEach((item: any) => {
      item.current = 0;
    });

    productCartList[elementIndex].quantity = quantity;
    productCartList[elementIndex].valueDelivery = valueDelivery;
    productCartList[elementIndex].operator = operator;
    productCartList[elementIndex].current = 1;

    productDetails = productCartList
  } else {
    const referencesToSend = amounts.map((fields) => ({
      id: fields.id,
      quantity: fields.quantity
    }))

    productCartList.forEach((item: any) => {
      item.current = 0;
    });

    productCartList[elementIndex].references = referencesToSend
    productCartList[elementIndex].valueDelivery = valueDelivery
    productCartList[elementIndex].operator = operator
    productCartList[elementIndex].current = 1;

    productDetails = productCartList
  }

  const data: any = {
    url: path,
    products: productDetails,
    origin: config.landingIdentifier,
  }
  
  if (cartId) {
    data.id = cartId
  }
  


  dispatch({ type: LOADING_CART })
  await _dataService
    .postElastic('/catalogue/shoppingcart', null, data)
    .then((res: AxiosResponse) => {
      if (res.status === 200 && res.data.success === true) {
        dispatch({
          type: ADD_PRODUCT,
          payload: {
            id: res.data.data.id,
            total: res.data.data.total,
            consumptionTaxAmountTotal: res.data.data.consumptionTaxAmountTotal,
            taxAmountTotal: res.data.data.taxAmountTotal,
            products: res.data.data.products,
            catalogueId: res.data.data.catalogueId,
            quantity: res.data.data.quantity,
            state: res.data.data.state,
            date: res.data.data.date,
            clientId: res.data.data.clientId,
            publicKey: res.data.data.publicKey,
            shippingCost: res.data.data.shippingCost,
          }
        })
        if (rediretPath) {
          history.push(
            `${rediretPath}/${res.data.data.id}`,
            { from: captureCartReturnPath() }
          )
          dispatch({
            type: IN_SUMMARY_PAGE,
            payload: false
          })
        }
        

      } else {
        if (res.data.titleResponse === 'shopping cart abandoned or deleted') {
          message('Carrito ha sido abandonado o eliminando')
          dispatch({
            type: DEACTIVATED_CART
          })
        } else {
          message(`${language[defaultLanguage]["error"]}.`)
          dispatch({
            type: CART_ERROR
          })
        }
      }
    })
    .catch((err) => {
      error(`${language[defaultLanguage]["error"]}.`)
      datadogLogs.logger.info('error request handleEditProduct', { name: 'post /catalogue/shoppingcart', body: data, error: err.message })
    })
}

export const handleRemoveProduct = (
  productId: number,
  cartId: number,
  path: string,
  idRef: any = "",
  defaultLanguage: string,
  lastProduct: boolean,
  catalogueName: string,
  history: any,
) => async(dispatch: any) => {
  
  if (cartId) {
    const _dataService = new DataService()
    
    
    const data: any = {
      url: path,
      productId: productId,
      referenceId: idRef,
      origin: config.landingIdentifier,
      id: cartId
    }
    
    

    dispatch({ type: LOADING_CART })
    await _dataService
      .post('/catalogue/shoppingcart/removeItem', data)
      .then((res: AxiosResponse) => {
        if (res.status === 200 && res.data.success === true) {
          if (!lastProduct) {
            dispatch({
              type: ADD_PRODUCT,
              payload: {
                id: res.data.data.id,
                total: res.data.data.total,
                consumptionTaxAmountTotal: res.data.data.consumptionTaxAmountTotal,
                taxAmountTotal: res.data.data.taxAmountTotal,
                catalogueId: res.data.data.catalogueId,
                products: res.data.data.products,
                quantity: res.data.data.quantity,
                state: res.data.data.state,
                date: res.data.data.date,
                clientId: res.data.data.clientId,
                publicKey: res.data.data.publicKey,
                shippingCost: res.data.data.shippingCost,
              }
            })
          } else {
            dispatch({
              type: EMPTY_CAR
            })
            history.push(`/vende/${catalogueUrlSegment(catalogueName)}/carrito/empty`)
          }
        } else {
            message(`${language[defaultLanguage]["error"]}.`)
            dispatch({
              type: CART_ERROR
            })
        }
      })
      .catch((err) => {
        datadogLogs.logger.info('error request handleRemoveProduct', { name: 'post /catalogue/shoppingcart/removeItem', body: data, error: err.message })
        error(`${language[defaultLanguage]["error"]}.`)
      })
  } else {
    message('No existe id del carrito')
  }
}

export const handleCartPriceX = (data: any) => (dispatch: any) => {
  let newPrice = totalPay(data.price, null, data.amounts)

  dispatch({
    type: UPDATE_TOTAL_PRICE,
    payload: newPrice
  })
}


export const findByReference = (id: number, referencesList: Array<any>) => {
  const result = referencesList.filter((ref) => ref.id === id)
  return result[0].title
}

export const findByPrice = (id: number, referencesList: Array<any>) => {
  const result = referencesList.filter((ref) => ref.id === id)
  return result[0].amount
}

export const handleIdentifyShoppingCart = (cartId: number, path: string, location: Location, history: any, defaultLanguage: string) => async(dispatch: any) => {
  const _dataService = new DataService()

  if (cartId) {
    const data = {
      url: path,
      id: cartId,
      origin: config.landingIdentifier
    }

    dispatch({ type: LOADING_CART })
    await _dataService
      .post('/catalogue/shoppingcart/find',data)
      .then((res: AxiosResponse) => {
        if (res.status === 200 && res.data.success === true) {
          const fromPurchase = new URLSearchParams(location.search || '').get('from') === 'purchase';

          if (res.data.data.state === 'eliminado') {
            history.push(location.pathname.substring(0, location.pathname.indexOf('carrito')))
            /*message(
              'El carrito de compras que desea visualizar ha sido vaciado anteriormente.'
            )*/
            dispatch({
              type: DEACTIVATED_CART
            })
              return
          }
          else if ((res.data.data.state === 'procesando_pago' && !fromPurchase) || res.data.data.state === 'pagado' || res.data.data.state === 'rechazado') {
            dispatch({
              type: DEACTIVATED_CART
            })
            return
          }   
          if (res.data.data.products.length > 0) {
            dispatch({
              type: ADD_PRODUCT,
              payload: {
                id: res.data.data.id,
                catalogueId: res.data.data.catalogueId,
                total: res.data.data.total,
                consumptionTaxAmountTotal: res.data.data.consumptionTaxAmountTotal,
                taxAmountTotal: res.data.data.taxAmountTotal,
                products: res.data.data.products,
                quantity: res.data.data.quantity,
                state: res.data.data.state,
                date: res.data.data.date,
                clientId: res.data.data.clientId,
                publicKey: res.data.data.publicKey,
                contactName: res.data.data.contactName,
                contactPhone: res.data.data.contactPhone,
                email: res.data.data.email,
                shippingCost: res.data.data.shippingCost,
              }
            })
          }
        }else{
          if (res.data.titleResponse === 'shopping cart abandoned or deleted') {
            
            message(language[defaultLanguage]["shoppingDelete"])
            dispatch({
              type: DEACTIVATED_CART
            })
            history.push(location.pathname.substring(0, location.pathname.indexOf('carrito')))
          } else {
            
            message(`${language[defaultLanguage]["error"]}.`)
            dispatch({
              type: CART_ERROR
            })
            history.push(location.pathname.substring(0, location.pathname.indexOf('carrito')))
          }
        } 
      })

      .catch((err) => {
        error(`${language[defaultLanguage]["error"]}.`)
        datadogLogs.logger.info('error request handleIdentifyShoppingCart', { name: 'post /catalogue/shoppingcart/find', body: data, error: err.message })
        history.push(location.pathname.substring(0, location.pathname.indexOf('carrito')))
      })
  } else {
    
    history.push(location.pathname.substring(0, location.pathname.indexOf('carrito')))
    error('No encontramos un carrito.')
  }
}

export const handleShipCart = (cartId: string, path: string, values: any, defaultLanguage: string, totalPay?: number, discountAmount: number = 0, detailTotal: any = {} ) => async(dispatch: any) => {
  const _dataService = new DataService() 
  const data: any = {
    url: path,
    id: cartId,
    origin: config.landingIdentifier,
    name: values.firstName,
    lastName: values.lastName,
    phone: values.phone,
    address: values.address1,
    property: values.housingType || 'N/A',
    shippingAmount: values.shippingAmount,
    city: values.city,
    country: values.country,
    countryName: values.countryName,
    countryCode: values.countryCode,
    region: values.departament === 'Bogotá Dc' ? 'Bogotá DC' : values.departament,
    other: values.address2,
    codeDane: values.codeDane,
    conditions: true,
    terms: true,
    landingIdentifier:"EPAYCO",
    contactName: `${values.firstName} ${values.lastName}`,
    contactPhone: values.phone,
    email: values.email,
    quote: values.quote,
    saveInfoShipping: values.saveInfoClient,
    discountCodes: values.discountCodes.map((item: Coupon) => item.code),
    amount: totalPay,
    discountAmount: discountAmount,
    detailTotal: detailTotal,
    documentNumber: values.documentId,
    documentType: values.documentType,
    sellerCode: values.sellerCode,
    commerceId: values.commerceId,
    branchId: values.branchId,
    deliveryType: values.deliveryType,
    streetType: values.streetType,
    streetName: values.streetName,
    streetNumber: values.streetNumber,
    crossNumber: values.crossNumber,
    housingType: values.housingType,
    locationDetail: values.locationDetail,
    additionalAddress: values.additionalAddress
  }

  if (values.isAveonline) {
    data.isAveonline = true;
    data.carrier = values.carrier;
    data.departamentoAveonline = values.departamentoAveonline || values.departament;
    data.municipioAveonline = values.municipioAveonline || values.city;
  }
  if (cartId) {
    try {
      const res: AxiosResponse = await _dataService.post('/catalogue/shoppingcart/shipping', data)
      dispatch({
        type: FIND_SHOPPING_CART,
        payload: {
          find: res
        }
      })
      return res.data
    } catch (err) {
      datadogLogs.logger.info('error request handleShipCart', { name: 'post /catalogue/shoppingcart/shipping', body: data, error: err.message })
      return err?.response?.data || null
    }
  } else {
    error(language[defaultLanguage]['noCartError'])
    return null
  }
}

// Revalida el carrito sin modificarlo (tienda, productos, categorías, referencias y precios)
export const validateShoppingCart = (cartId: string, path: string) => async() => {
  const _dataService = new DataService()
  const data = { url: path, id: cartId }
  try {
    const res: AxiosResponse = await _dataService.post('/catalogue/shoppingcart/validate', data)
    return res.data
  } catch (err) {
    datadogLogs.logger.info('error request validateShoppingCart', { name: 'post /catalogue/shoppingcart/validate', body: data, error: err.message })
    return err?.response?.data || null
  }
}

export const handleRebuyFromPurchase = (
  products: Array<any>,
  path: string,
  catalogueName: string,
  defaultLanguage: string,
  history: any,
  clientId?: number,
) => async (dispatch: any, getState: any) => {
  const mbState = getState();
  const marcaBlancaMaxUnits = mbState.marcaBlanca?.client?.maxDataphoneUnits ?? 0;
  if (
    shouldShowMarcaBlancaModal(mbState.client?.id, config.marcaBlancaId) &&
    exceedsMarcaBlancaLimit(mbState.shoppingCart.cartInfo, getCartUnits(products), marcaBlancaMaxUnits)
  ) {
    dispatch(showMarcaBlancaCartLimit());
    return;
  }
  const _dataService = new DataService();
  dispatch({ type: LOADING_CART });

  let cartId: any = null;
  let navigated = false;
  let lastCartData: any = null;

  const getProductRequestData = (product: any) => {
    const hasRef =
      Array.isArray(product?.references) && product.references.length > 0;
    return {
      productId: product?.productData?.id ?? product?.id,
      referenceId: hasRef ? product.references[0].id : '',
      quantity: hasRef ? product.references[0].quantity : product.quantity,
      operator: product?.operador ?? product?.operator ?? '',
      valueDelivery: product?.valor_envio ?? product?.valueDelivery ?? 0,
    };
  };

  const canAttemptProduct = (product: any) => {
    const requestData = getProductRequestData(product);
    return Boolean(
      requestData.productId && Number(requestData.quantity) > 0,
    );
  };

  const sendProduct = async (product: any, targetCartId: any) => {
    const {
      productId,
      referenceId,
      quantity,
      operator,
      valueDelivery,
    } = getProductRequestData(product);

    if (!productId || Number(quantity) <= 0) return { ok: false, data: null };

    const body: any = {
      url: path,
      origin: config.landingIdentifier,
      id: targetCartId,
      productId,
      referenceId,
      quantity,
      operator,
      valueDelivery,
    };
    if (clientId) body.clientId = clientId;

    const res = await _dataService.post('/catalogue/shoppingcart', body);
    const success =
      res.status === 200 &&
      res.data.success === true &&
      !!res.data.data &&
      !!res.data.data.id;
    return { ok: success, data: success ? res.data.data : null };
  };

  const applyResponse = (data: any) => {
    dispatch({
      type: ADD_PRODUCT,
      payload: {
        id: data.id,
        total: data.total,
        products: data.products,
        consumptionTaxAmountTotal: data.consumptionTaxAmountTotal,
        taxAmountTotal: data.taxAmountTotal,
        catalogueId: data.catalogueId,
        quantity: data.quantity,
        state: data.state,
        date: data.date,
        clientId: data.clientId,
        publicKey: data.publicKey,
        shippingCost: data.shippingCost,
      },
    });
  };

  const navigateToCart = () => {
    if (navigated || !cartId) return;
    navigated = true;
    dispatch({ type: IN_SUMMARY_PAGE, payload: false });
    history.push(
      `/vende/${catalogueUrlSegment(catalogueName)}/carrito/${cartId}`,
      { from: captureCartReturnPath() }
    );
  };

  const logProductError = (err: any) => {
    datadogLogs.logger.info('error request handleRebuyFromPurchase', {
      name: 'post /catalogue/shoppingcart (rebuy)',
      error: err?.message,
    });
  };

  try {
    const rebuyProducts = products.filter(canAttemptProduct);

    for (let index = 0; index < rebuyProducts.length; index++) {
      const product = rebuyProducts[index];
      try {
        const result = await sendProduct(product, cartId);
        if (result.ok && result.data) {
          cartId = result.data.id;
          lastCartData = result.data;
          applyResponse(result.data);
          navigateToCart();

          if (index < rebuyProducts.length - 1) {
            dispatch({ type: LOADING_CART });
          }
        }
      } catch (err: any) {
        logProductError(err);
      }
    }

    if (!navigated) {
      history.push(`/vende/${catalogueUrlSegment(catalogueName)}`);
    } else if (lastCartData) {
      applyResponse(lastCartData);
    }
  } catch (err: any) {
    datadogLogs.logger.info('error request handleRebuyFromPurchase', {
      name: 'post /catalogue/shoppingcart (rebuy)',
      error: err.message,
    });

    if (!navigated) {
      error(`${language[defaultLanguage]['error']}.`);
      history.push(`/vende/${catalogueUrlSegment(catalogueName)}`);
    } else if (lastCartData) {
      applyResponse(lastCartData);
    }
  }
};

export const handleRefProductEdit = (refId: number | null) => async (dispatch: any) => {
  dispatch({ 
    type: REF_PRODUCT_EDIT,
    payload: {
      refId: refId
    }
  })
}

export const updateQuantityCounter = (data: any) => async (dispatch: any) => {
  dispatch({ 
    type: UPDATE_QUANTITY_COUNTER,
    payload: [
      ...data
    ]
  })
}

export const updateTax = (taxAmountTotal: number, consumptionTaxAmountTotal: number) => async (dispatch: any) => {
  dispatch({ 
    type: UPDATE_TAX,
    payload: {
      taxAmountTotal,
      consumptionTaxAmountTotal
    }
  })
}
